import z from 'zod'
import { decimalSchema } from '../../utils/schema'

/**
 * Backpack `InterestPayment` レスポンススキーマ。
 * `paymentType` は EntryFee / Borrow / Lend / UnrealizedPositivePnl / UnrealizedNegativePnl。
 * 数量の符号は `paymentType` に応じて判定する:
 * - Lend: 受取 (in)
 * - Borrow / EntryFee / UnrealizedNegativePnl の利息: 支払 (out)
 * - UnrealizedPositivePnl の利息: 受取 (in)
 */
export const interestPaymentSchema = z.object({
  /** 支払い種別 */
  paymentType: z.enum([
    'EntryFee',
    'Borrow',
    'Lend',
    'UnrealizedPositivePnl',
    'UnrealizedNegativePnl',
  ]),
  /** 利率 */
  interestRate: decimalSchema,
  /** 利息計算の interval duration */
  interval: z.number(),
  /** 関連 market シンボル */
  marketSymbol: z.string(),
  /** 関連 borrow lend position の ID */
  positionId: z.string(),
  /** 利息支払い量 (絶対値、符号は paymentType で判定) */
  quantity: decimalSchema,
  /** 利息支払いの対象アセット */
  symbol: z.string(),
  /** 利息支払い時刻 (naive ISO date-time) */
  timestamp: z.string(),
})

export const interestPaymentsResponseSchema = z.array(interestPaymentSchema)

export type InterestPayment = z.infer<typeof interestPaymentSchema>
